import React from 'react';
import PropTypes from 'prop-types';

export default class LoginButton extends React.Component {

  static propTypes = {
    actionUrl: PropTypes.string,
  };

  render() {

    let actionUrl = this.props.actionUrl;

    return (
      <a data-tracking-action="usermenu_login"
         href={actionUrl} className="td_aperza_component_usermenu header_userNoLogin">
        <img src="//static.aperza.jp/common/images/img_userLogin.svg"/>
      </a>
    )

  }

}


// WEBPACK FOOTER //
// ./src/LoginButton.js